import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/lib/site-config";

const Datenschutz = () => {
  useEffect(() => {
    document.title = `Datenschutz · ${SITE.brand.fullName}`;
  }, []);
  return (
    <div className="min-h-screen bg-[#5C6B49] text-[#F3F1E8] py-16 px-4 sm:px-6 lg:px-8" data-testid="datenschutz-page">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#C9C6B4] hover:text-[#E8E5D0] text-sm font-bold uppercase tracking-wider mb-10"
        >
          <ArrowLeft size={14} /> Zurück
        </Link>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95] mb-10">
          Datenschutzerklärung
        </h1>
        <div className="space-y-6 text-[#E5E2D0] text-[15px] leading-relaxed [&_h2]:font-display [&_h2]:font-black [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-[#F3F1E8] [&_h3]:font-bold [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-[#F3F1E8] [&_p]:text-[#C9C6B4] [&_strong]:text-[#F3F1E8]">
          <h2>1. Verantwortlicher</h2>
          <p>
            <strong>{SITE.brand.fullName}</strong>
            <br />
            {SITE.contact.address.street}, {SITE.contact.address.zip}{" "}
            {SITE.contact.address.city}
            <br />
            E-Mail: {SITE.contact.email}
            <br />
            Telefon: {SITE.contact.phoneDisplay}
          </p>

          <h2>2. Erhebung personenbezogener Daten bei Kontaktaufnahme</h2>
          <p>
            Wenn Sie uns über das Kontaktformular, WhatsApp, Telefon oder per
            E-Mail kontaktieren, verarbeiten wir folgende personenbezogene
            Daten: Vorname, Nachname, Mobilnummer, ggf. Festnetznummer,
            E-Mail-Adresse, Wohnort sowie Inhalt Ihrer Nachricht.
          </p>
          <p>
            Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines
            Vertragsverhältnisses) bzw. Art. 6 Abs. 1 lit. a DSGVO
            (Einwilligung).
          </p>

          <h2>3. Speicherdauer</h2>
          <p>
            Anfragen werden bis zur abschließenden Bearbeitung Ihrer
            Kontaktaufnahme bzw. so lange gespeichert, wie es gesetzliche
            Aufbewahrungspflichten erfordern.
          </p>

          <h2>4. Weitergabe an Dritte</h2>
          <p>
            Eine Weitergabe an Dritte erfolgt nicht, außer an
            Auftragsverarbeiter (z. B. E-Mail-Versanddienst Resend, MongoDB
            Atlas Hosting), mit denen entsprechende Verträge zur
            Auftragsverarbeitung (AVV) geschlossen wurden.
          </p>

          <h2>5. WhatsApp Business</h2>
          <p>
            Wenn Sie uns über WhatsApp kontaktieren, werden Daten an die WhatsApp
            Ireland Ltd. übermittelt. Details finden Sie in der
            Datenschutzerklärung von WhatsApp.
          </p>

          <h2>6. Ihre Rechte</h2>
          <p>
            Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung
            (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art.
            18), Datenübertragbarkeit (Art. 20) sowie Widerspruch (Art. 21) und
            Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO).
          </p>

          <h2>7. Cookies</h2>
          <p>
            Wir verwenden technisch notwendige Cookies sowie nach Einwilligung
            ggf. Cookies zur Reichweitenmessung. Sie können Ihre Einwilligung
            jederzeit über den Cookie-Banner widerrufen.
          </p>

          <h2>8. Beschwerderecht</h2>
          <p>
            Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu
            beschweren (Art. 77 DSGVO).
          </p>

          <h2>9. Nutzung von Künstlicher Intelligenz (EU AI Act)</h2>
          <p>
            Diese Website interagiert nicht mit Ihnen über KI-Systeme im Sinne
            von Art. 50 der Verordnung (EU) 2024/1689 (EU AI Act). Weder ein
            KI-Chatbot, noch ein KI-Sprachassistent, noch KI-gestützte
            automatische Antworten sind aktiv. Anfragen über das
            Kontaktformular, WhatsApp und Telefon werden persönlich von Tobias
            Nunner beantwortet.
          </p>
          <p>
            Sollten wir zukünftig KI-basierte Funktionen (z. B. Chatbot,
            automatisierte Erstantworten oder KI-generierte Bilder von realen
            Personen) einsetzen, werden diese entsprechend Art. 50 EU AI Act
            klar und deutlich als solche gekennzeichnet.
          </p>

          <h2>10. Aktualität</h2>
          <p>
            Diese Datenschutzerklärung wird laufend an aktuelle rechtliche und
            tatsächliche Gegebenheiten angepasst.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
